module.exports = "<div class=\"project-new-btn-wrapper\">\n    <div class=\"project-new-btn-overlap cursor\"></div>\n    <button class=\"project-new-btn\" ng-click=\"vm.addProject()\">\n        <div class=\"plus-container\">\n            <div class=\"plus\">+</div>\n        </div>\n        <div class=\"text\">Add Project</div>\n    </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/projects/project-new/project-new.tpl.html
// module id = 1819
// module chunks = 0